export default "<app-rteview></app-rteview>"